import { render, staticRenderFns } from "./addProject.vue?vue&type=template&id=3ba31064&scoped=true"
import script from "./addProject.vue?vue&type=script&lang=js"
export * from "./addProject.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./addProject.vue?vue&type=style&index=1&id=3ba31064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba31064",
  null
  
)

export default component.exports